module.exports = __webpack_public_path__ + "img/guide10.dd72e73e.jpg";